(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldImage', fbFieldImage);

    function fbFieldImage($compile, lodash, $templateRequest) {
        return {
            restrict: "E",
            scope: {
                element: "=",
                model: "="
            },
            templateUrl: 'common/components/image-upload/upload-wrapper',
            controller: fbFieldImageCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: link
        };

        function link(scope, elem) {
            //var imagePath = {'background-image': (model.default) ? model.default_file_url : model.file_url};
            var vm = scope.vm;
            elem.find('.k-upload').addClass('image-upload');
            vm.defaultProfileUrl = lodash.get(vm.element, 'options.defaultProfileUrl', "https://content.recruiterpal.com/app/assets/images/common/default.jpeg");

            $templateRequest('common/components/image-upload/image-preview').then(function (html) {
                var imgElement = angular.element(html);
                var imgElementCompiled = $compile(imgElement.contents())(scope);

                elem.find('.k-dropzone').prepend(imgElementCompiled);

                scope.$on('$destroy', function () {
                    imgElementCompiled.off();
                });
            });
        }
    }


    function fbFieldImageCtrl($scope, $element, lodash, FormBuilderService, SodLogger, $http, CommonHelper) {
        var vm = this;
        var formIdentifier = '';
        var element_name = '';
        var defaultModel = {};
        var files = {};

        this.$onInit = function() {
            formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            element_name = lodash.get(vm.element, 'attr.upload_data.hid_file_type', vm.element.elementIdentifier);
            vm.onLoadEventOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onLoad');

            vm.removeImage = removeImage;

            defaultModel = angular.copy(vm.model);

       
        if (lodash.has(vm.model, 'default') && !vm.model.default) {
            files = vm.model;
        }

            initEventOptions();

            vm.upload_options = {
                multiple: false,
                async: lodash.get(vm.onLoadEventOptions, 'async', {}),
                upload: uploadEvent,
                remove: removeEvent,
                success: successEvent,
                error: errorEvent,
                cancel: cancelEvent,
                files: files,
                showFileList: false,
            };
        }


        function initEventOptions() {
            if (lodash.has(vm.onLoadEventOptions, 'async')) {
                const formDraftId = lodash.get(vm.pageData, 'model.hid_form_draft_id', '');
                vm.onLoadEventOptions.async.removeUrl = decodeURI(vm.onLoadEventOptions.async.removeUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
                vm.onLoadEventOptions.async.saveUrl = decodeURI(vm.onLoadEventOptions.async.saveUrlTemplate).replace(new RegExp('<id>', 'g'), formDraftId);
            }
        }

        function uploadEvent(e) {
            if (lodash.has(vm.onLoadEventOptions, 'fileSize')) {
                if (e.files[0].size > vm.onLoadEventOptions.fileSize) {
                    // var wrapper = $element.parents('label');
                    //
                    // wrapper.addClass('error');
                    //
                    // var msg = lodash.get(vm, 'element.validation.fileSize', 'File should not be greater than 1 MB');
                    //
                    // wrapper.find('.error-message-wrapper').html("<div class='error-message'>" + msg + "</div>");
                    // e.preventDefault();
                    e.preventDefault();

                    var sizing = CommonHelper.bytesToSize(vm.onLoadEventOptions.fileSize);
                    var limitFileMessage = lodash.get(vm, 'element.options.limitFileMessage', 'File should not be greater than');
                    vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, [lodash.get(vm, 'element.validation.fileSize', limitFileMessage+' '+sizing)], true);
                   
                    $scope.$apply();
                    return;
                }
            }

            if (lodash.has(vm.element, 'attr.sender_name')) {
                e.sender.name = vm.element.attr.sender_name;
            }
            e.data = lodash.get(vm, 'element.attr.upload_data', {});
        }

        function cancelEvent(e) {
            SodLogger.debug('CANCEL EVENT TRIGGERED', e, this);
        }

        function removeEvent(e) {
            SodLogger.debug('REMOVE EVENT TRIGGERED', e, this);
            e.sender.options.async.removeUrl = vm.onLoadEventOptions.async.removeUrl + e.files[0].file_id;
            vm.model = defaultModel;
            $scope.$apply();
        }

        function successEvent(e) {
            if (e.operation == "upload") {
                e.files[0].file_id = e.response.data.file_id;
            }
            angular.merge(vm.model, e.response.data);
            vm.model.default = false;
            delete vm.model.remove_image;
            defaultModel = angular.copy(vm.model);
            $scope.$apply();
            $element.parents('.error').removeClass('error').find('.error-message').remove();
        }

        function errorEvent(e) {
            if (e.XMLHttpRequest.status == 422) {
                var rules = JSON.parse(e.XMLHttpRequest.response);
                vm.pageData.elementsService.setValidationError(vm.element.elementIdentifier, lodash.get(rules.rules, vm.element.elementIdentifier, []));
                $scope.$apply();
                // var eventData = {
                //     rules:  {
                //         'validate': {
                //             rules: rules.rules,
                //             summary: '',
                //             form_name: ''
                //         }
                //     },
                //     targetScope: vm.element,
                //     target: $element,
                //     event: e,
                //     model: vm.model
                // };
                // $scope.$emit('validate.file', eventData);
            }
        }

        function removeImage() {
            vm.model.file_url = null;
            vm.model.default = true;
            vm.model.remove_image = true;


            if (typeof vm.model.file_id !== typeof undefined) {
                $http({
                    method: 'delete',
                    url: vm.onLoadEventOptions.async.removeUrl + vm.model.file_id,
                });
            }


            defaultModel = angular.copy(vm.model);
            $element.find('.k-dropzone .k-upload-status').remove();
        }
    }
})();
